<template>
    <div>
        <v-select dir="rtl" label="title" @option:selected="selectPreferenceType" :placeholder="txtPlaceholder" :filterable="false" :searchable="false" :options="PreferenceTypeList" :reduce="p => p.preferenceTypeId" v-model="preferenceId">

        </v-select>
    </div>
</template>
<script>

    export default {
        props: ['txtPlaceholder'],
        data() {
            return {
                placeholder: this.txtPlaceholder,
                preferenceId: null
            }
        },
        watch: {
            'preferenceId'(value) {
                if (!value) {
                    this.preferenceId = null;
                    this.$emit('selectPreferenceType', this.preferenceId);
                }
            }
        },
        computed: {
            PreferenceTypeList() {
                return this.$store.getters.GetPreferenceTypeList;
            },
        },
        methods: {
            selectPreferenceType(d) {
                this.preferenceTypeId = d.preferenceTypeId;
                this.$emit('selectPreferenceType', this.preferenceTypeId);
            },
        },
        created() {
            this.$store.dispatch("GetPreferenceTypeListFromServer", {});
        }
    }
</script>
